import tippy from 'tippy.js';

class Tooltip {
    init() {
        this.initTippy('.tooltip', '.tooltip-like');
    }

    initRVP() {
        this.initTippy('.rvpContainer .tooltip', '.rvpContainer .tooltip-like');
    }

    initTippy(tippySelect, tippyTooltipLike) {
        tippy(tippySelect, {
            dynamicTitle: true,
            position: 'right',
            arrow: true,
            popperOptions: {
                modifiers: {
                    flip: {
                        behavior: ['right', 'top']
                    }
                }
            },
        });

        tippy(tippyTooltipLike, {
            position: 'top',
            arrow: true,
            dynamicTitle: true
        });
    }
}

export default Tooltip;
